import { Component } from '@angular/core';

@Component({
    selector: 'fe-promotion-reasons',
    templateUrl: './promotion-reasons.component.html',
    styleUrls: ['./promotion-reasons.component.scss'],
})
export class PromotionReasonsComponent {
    public readonly rentalReasons = [
        {
            icon: 'images/promo-cancelacion.svg',
            title: 'fe_coupon_promotions_reason_1_title',
            text: 'fe_coupon_promotions_reason_1_text',
        },
        {
            icon: 'images/promo-cobertura.svg',
            title: 'fe_coupon_promotions_reason_2_title',
            text: 'fe_coupon_promotions_reason_2_text',
        },
        {
            icon: 'images/like_purple.svg',
            title: 'fe_coupon_promotions_reason_3_title',
            text: 'fe_coupon_promotions_reason_3_text',
        },
        {
            icon: 'images/promo-flota.svg',
            title: 'fe_coupon_promotions_reason_4_title',
            text: 'fe_coupon_promotions_reason_4_text',
        },
    ];
}
